import { useEffect, useMemo } from 'react';
import QueryKeys from 'hooks/queries/keys';
import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import BarGraph from 'pages/InsightsPage/visualizations/BarGraph';
import { BarGraphProps } from 'pages/InsightsPage/visualizations/BarGraph/BarGraph';
import CustomTooltip from 'pages/InsightsPage/visualizations/CustomTooltip';

type BarGraphDatum = {
    received_text: string;
    response_count: string;
    response_percentage: string;
};

type Props = {
    filtersForApi?: FiltersForApiState;
};

const ResponseByKeywordCard = ({ filtersForApi }: Props) => {
    const campaignId = filtersForApi.campaigns[0];

    const { getData, isError, isLoading, data } = useFilteredData({
        key: QueryKeys.RESPONSE_BY_KEYWORD(campaignId),
        path: CuredApiPaths.REPORT_SMS_RESPONSE_BY_KEYWORD,
    });

    const autoResponseFiltersForApi = useMemo(
        () => ({
            ...filtersForApi.timeframe,
            campaignId,
        }),
        [campaignId, filtersForApi.timeframe]
    );

    useEffect(() => {
        getData(autoResponseFiltersForApi);
    }, [autoResponseFiltersForApi, getData]);

    const barGraphData = data?.map((datum: BarGraphDatum) => ({
        id: datum.received_text,
        label: datum.received_text,
        value: datum.response_percentage,
        count: datum.response_count,
    }));

    return (
        <Card isError={isError} isLoading={isLoading} label="Response by Keyword">
            <BarGraph
                bottomLegendLabel="% of total responses"
                data={barGraphData as BarGraphProps['data']}
                layout="horizontal"
                leftLegendLabel="keywords"
                renderCustomTooltip={(datum) => (
                    <CustomTooltip
                        color={datum.color}
                        label={`${datum.value}% of total responses`}
                        value={`count: ${datum.data.count}`}
                    />
                )}
                useSingleColor={false}
            />
        </Card>
    );
};

export default ResponseByKeywordCard;
